import { IStorage } from './IStorage';
import { LocalStorageAdapter } from './LocalStorageAdapter';
import { platform } from './platform';

/**
 * Storage singleton instance
 * Currently uses LocalStorageAdapter for both web and Electron
 * Can be extended to use ElectronSecureStorage in the future
 */

// For now, use LocalStorageAdapter for both platforms
// This works in both web browsers and Electron
const createStorage = (): IStorage => {
  // Future: Add conditional logic for electron-store
  // if (platform.isElectron && process.env.REACT_APP_USE_SECURE_STORAGE === 'true') {
  //   return new ElectronSecureStorage();
  // }
  
  return new LocalStorageAdapter();
};

/**
 * Unified storage instance
 * Use this throughout the application for all storage operations
 */
export const storage: IStorage = createStorage();

// Re-export types and utilities
export type { IStorage } from './IStorage';
export { platform } from './platform';
export { LocalStorageAdapter } from './LocalStorageAdapter';
